const pathnameIncludesAfterKey = key => {
  return traffic => {
    const urlObject = new URL(traffic.url.toLowerCase())
    const pathnameParts = urlObject.pathname.split('/')
    const value = pathnameParts[pathnameParts.indexOf(key) + 1]
    return value !== null
  }
}

export default pathnameIncludesAfterKey



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/predicates/pathnameIncludesAfterKey.js